<template>
  <div>
    <v-card
      flat
      class="rounded-lg mt-5 textLight--text px-4 px-md-2"
      @click="$emit('onClick')"
    >
      <v-row align="center" class="pa-3 pa-md-0">
        <!--course-->
        <v-col cols="12" md class="text-start ps-md-7">
          <div class="text-ellipse-1 text-start">
            {{
              data.trainingTitle ? getLocalisedValue(data.trainingTitle) : "-"
            }}
          </div>
        </v-col>

        <!--total employees-->
        <v-col cols="6" sm="3" md="2">
          <div class="text-center">
            {{
              data.filteredTrainingRegistrations
                ? data.filteredTrainingRegistrations.length
                : "-"
            }}
          </div>
        </v-col>

        <!--total quantity-->
        <v-col cols="6" sm="3" md="2">
          <div class="text-center">
            {{ data.quantity != null ? data.quantity : "-" }}
          </div>
        </v-col>

        <!--unit price-->
        <v-col cols="6" sm="3" md="2">
          <div class="text-center">
            {{
              data.unitPrice != null
                ? data.unitPrice - (data.discount || 0)
                : "-"
            }}
          </div>
        </v-col>

        <!--total price-->
        <v-col cols="6" sm="3" md="2">
          <div class="text-center">
            {{ data.amount != null ? data.amount : "-" }}
          </div>
        </v-col>

        <!--delete button-->
        <v-col cols="12" md="1" class="text-end text-md-center">
          <v-btn depressed icon @click.stop="$emit('onDelete')">
            <v-icon color="error"> mdi-trash-can-outline </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "InvoiceOrderItemsTableRow",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>
